import Header from './components/Header';
import HeroCards from './components/HeroCards';
import KeywordWall from './components/KeywordWall';
import CategoryBoard from './components/CategoryBoard';
import HotRank from './components/HotRank';
import Discussion from './components/Discussion';
import CtaPanel from './components/CtaPanel';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-[#fffaf3] text-stone-800">
      <Header />
      <main className="flex-1">
        <HeroCards />
        <KeywordWall />
        <CategoryBoard />
        <HotRank />
        <Discussion />
        <CtaPanel />
      </main>
      <Footer />
    </div>
  );
}